import React, { useState } from "react";
import { optimizeRoute } from "../services/routeOptimizationService";

const RouteOptimizationPage = () => {
    const [matrixText, setMatrixText] = useState("0,10,15\n10,0,20\n15,20,0");
    const [result, setResult] = useState(null);
    const [error, setError] = useState("");

    const parseMatrix = () => {
        return matrixText
            .trim()
            .split("\n")
            .map((row) =>
                row
                    .split(",")
                    .map((value) => Number(value.trim()))
            );
    };

    const handleOptimize = async () => {
        try {
            setError("");
            setResult(null);

            const distances = parseMatrix();

            const data = await optimizeRoute(distances);
            setResult(data);
        } catch (err) {
            console.error(err);
            setError("Failed to optimize route. Check the matrix format.");
        }
    };

    return (
        <div style={{ padding: "24px", maxWidth: "800px", margin: "0 auto" }}>
            <h2>Route Optimization</h2>

            <p>Enter a square distance matrix. Example:</p>

            <pre>0,10,15{"\n"}10,0,20{"\n"}15,20,0</pre>

            <textarea
                value={matrixText}
                onChange={(e) => setMatrixText(e.target.value)}
                rows={8}
                style={{ width: "100%", padding: "10px" }}
            />

            <br />

            <button onClick={handleOptimize} style={{ marginTop: "12px" }}>
                Optimize Route
            </button>

            {error && <p style={{ color: "red" }}>{error}</p>}

            {result && (
                <div style={{ marginTop: "20px" }}>
                    <h3>Optimization Result</h3>
                    <p>
                        <strong>Optimized Route:</strong>{" "}
                        {result.optimizedRoute?.join(" → ")}
                    </p>
                    <p>
                        <strong>Total Distance:</strong> {result.totalDistance}
                    </p>
                </div>
            )}
        </div>
    );
};

export default RouteOptimizationPage;